import React from 'react'
import "./Footer.scss"
import ImageElement from "./ImageElement";
import { Line } from 'react-chartjs-2';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { Badge, Nav, NavDropdown, Navbar } from 'react-bootstrap'
// import Header from "../components/header.js"
export default function Footer() {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  const wp_token = useSelector((state) => state?.auth?.userInfo?.wp_token || "");

  return (
    <>
      <footer className="footer">
        <div className="container footer-content">
          <div className="footer-top d-md-flex justify-content-between w-100">
            <div className="footer-left">
              <div className="footer-logo">

                <ImageElement source={"footer-logo.svg"} alt={'logo'} />
                <ul>
                  {/* <li><a href="#"><ImageElement source={"facebook-icon.svg"} alt={'facebook'} /></a></li> */}
                  <li>
                    <a href='https://www.linkedin.com/in/asessohealth' target='_blank' rel='noopener noreferrer'>
                      <ImageElement source={"linkedin-icon.svg"} alt={'linkedin-icon'} />
                    </a>                  
                  </li>
                  {/* <li><a href="#"><ImageElement source={"x-icon.svg"} alt={'x-icon'} /></a></li> */}
                  {/* <li><a href="#"><ImageElement source={"instagram.svg"} alt={'instagram.svg'} /></a></li> */}
                </ul>
              </div>
            </div>
            <div className="footer-right d-flex">
              <ul>
                <li><Link to={`${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/products/?t=${wp_token}`}>Products</Link></li>
                <li><Link to={`${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/products/asesso-grindguard/?t=${wp_token}`} className='text-decoration-none'>Asesso™ GrindGuard</Link></li>
                <li><Link to={`${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/products/motion-sensor/?t=${wp_token}`} className='text-decoration-none'>Asesso Sensor</Link></li>
                <li><Link to={`${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/asesso-experience/?t=${wp_token}`} className='text-decoration-none'>Asesso Experience</Link></li>
              </ul>
              <ul>
                <li><Link to={`${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/pricing/?t=${wp_token}`} className='text-decoration-none'>Pricing</Link></li>
                <li><Link to={`${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/about/?t=${wp_token}`} className='text-decoration-none'>About</Link></li>
                {/* <li><a href="">Support</a></li> */}
              </ul>
              <ul>
                <li><Link to="/my_profile" className='text-decoration-none' >Go to Profile</Link></li>
                {/* <li><a href="">Sign-up</a></li>
          <li><a href="">For Dentist</a></li> */}
              </ul>
            </div>
          </div>
          <div className="footer-bottom d-sm-flex justify-content-between w-100 text-center">
            <p className="text-white">© {currentYear} Asesso. All Rights Reserved.</p>
            <ul>
              
              <li><Link to={'/about/privacy_policy'} className='text-decoration-none' target="__blank">Privacy Notice</Link></li>
              <li><Link to={'/about/term_of_service'} className='text-decoration-none' target="__blank">Terms of Service</Link></li>
              <li><Link to={'/HIPPA'} className='text-decoration-none' target="__blank">Notice of Privacy Practices </Link></li>
              <li><Link to={'/about/term_of_purchase'} className='text-decoration-none' target="__blank">Terms of Purchase</Link></li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}